import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
} from "react-router-dom";
import {useParams} from "react-router";
import Layout from "../components/Layout/Layout";
import WelcomePage from "../pages/WelcomePage";
import NotFound from "../components/NotFound";
import ParentPage from "../pages/ParentPage";
import AddressPage from "../pages/AddressPage";
import StudentsPage from "../pages/StudentsPage";
import ConfirmationPage from "../pages/ConfirmationPage";
import CompletePage from "../pages/CompletePage";
import {ROUTES} from "./config";

const StudentsPageRouteElement = () => {
    const {childId} = useParams();
    return <StudentsPage key={childId || ""} />;
};

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route>
            <Route element={<Layout/>}>
                <Route path={ROUTES.WELCOME} element={<WelcomePage/>}/>
                <Route path=":applicationId">
                    <Route path={ROUTES.PARENT} element={<ParentPage/>}/>
                    <Route path={ROUTES.ADDRESS} element={<AddressPage/>}/>
                    <Route path={`${ROUTES.STUDENTS}/:childId?`} element={<StudentsPageRouteElement/>}/>
                    <Route path={ROUTES.CONFIRMATION} element={<ConfirmationPage/>}/>
                </Route>
                <Route path={ROUTES.COMPLETE} element={<CompletePage/>}/>
                <Route path="*" element={<NotFound/>}/>
            </Route>
        </Route>,
    ),
);
